import { API_URL } from '../config/api';

const DEFAULT_ICON = '/assets/BizTrack_Logo.png';
const DEFAULT_TITLE = 'BizTrack CRM';

const isRemoteAsset = (value) => /^(https?:|data:|blob:)/i.test(value);

const resolveAppAsset = (value) => {
  const source = String(value || '').trim();
  if (!source) return '';
  if (isRemoteAsset(source)) return source;
  if (source.startsWith('/uploads/') || source.startsWith('/api/')) return `${API_URL}${source}`;
  if (source.startsWith('/')) return source;
  return source;
};

export const getBrandImageUrl = (value) => resolveAppAsset(value) || DEFAULT_ICON;

export const getProfileImageUrl = (value) => {
  const source = String(value || '').trim();
  if (!source) return '';
  if (isRemoteAsset(source)) return source;
  if (source.startsWith('/uploads/') || source.startsWith('/api/')) return `${API_URL}${source}`;
  if (source.startsWith('/')) return source;
  return `${API_URL}/api/profile/pic/${encodeURIComponent(source)}`;
};

const getIconType = (href) => {
  if (/\.ico($|\?)/i.test(href)) return 'image/x-icon';
  if (/\.svg($|\?)/i.test(href)) return 'image/svg+xml';
  if (/\.jpe?g($|\?)/i.test(href)) return 'image/jpeg';
  return 'image/png';
};

const setLinkIcon = (rel, href) => {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
  link.type = getIconType(href);
};

const createInitialIcon = (label, color = '#0b66ae') => {
  if (typeof document === 'undefined') return DEFAULT_ICON;
  const cleanLabel = String(label || '').trim().replace(/^(BizTrack\s*-\s*|Super\s*Admin\s*-\s*)/i, '');
  const initial = (cleanLabel || DEFAULT_TITLE).charAt(0).toUpperCase() || 'B';
  const canvas = document.createElement('canvas');
  canvas.width = 96;
  canvas.height = 96;
  const context = canvas.getContext('2d');
  const gradient = context.createLinearGradient(0, 0, 96, 96);
  gradient.addColorStop(0, color || '#0b66ae');
  gradient.addColorStop(1, '#10b981');
  context.fillStyle = gradient;
  
  if (context.roundRect) {
    context.beginPath();
    context.roundRect(0, 0, 96, 96, 18);
    context.fill();
  } else {
    context.fillRect(0, 0, 96, 96);
  }

  context.fillStyle = '#ffffff';
  context.font = 'bold 52px Arial, sans-serif';
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillText(initial, 48, 52);
  return canvas.toDataURL('image/png');
};

export const setBrowserBranding = ({ title, icon, fallbackText, themeColor }) => {
  if (typeof document === 'undefined') return;

  const cleanTitle = String(title || '').trim() || DEFAULT_TITLE;
  const cleanIcon = String(icon || '').trim() || createInitialIcon(fallbackText || cleanTitle, themeColor);
  const iconHref = /^(data:|blob:)/i.test(cleanIcon)
    ? cleanIcon
    : `${cleanIcon}${cleanIcon.includes('?') ? '&' : '?'}v=${encodeURIComponent(cleanTitle)}`;
  document.title = cleanTitle;

  setLinkIcon('icon', iconHref);
  setLinkIcon('shortcut icon', iconHref);
  setLinkIcon('apple-touch-icon', iconHref);

  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme && themeColor) metaTheme.setAttribute('content', themeColor);
};
